import { DextDateTimeInputWUT } from '@wix/form-fields/viewer-wut';

export default DextDateTimeInputWUT;
